export const anchorInner = 5;
export const anchorBleed = 5;
